<!-- @veltra/icons generated sha256:e71916af138d1c83 gen:8 source:src/svg/normal/credit-card.svg -->
<script setup lang="ts">
defineOptions({ name: 'CreditCard' })
</script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="M15 4v8a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1m-1 1.5V4H2v1.5zm-12 1V12h12V6.5zM5.988 11H4.012a.51.51 0 0 1-.512-.496c0-.276.235-.504.512-.504h1.976c.277 0 .512.228.512.496a.513.513 0 0 1-.512.504"
    />
  </svg>
</template>
